var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18497 3.91248H5.8154C6.01581 3.91248 6.17772 4.07439 6.17772 4.2748V10.4342C6.17772 10.6346 6.01581 10.7965 5.8154 10.7965H4.18497C3.98456 10.7965 3.82265 10.6346 3.82265 10.4342V4.2748C3.82265 4.07439 3.98456 3.91248 4.18497 3.91248ZM0.697648 0.651611H2.32808C2.52849 0.651611 2.6904 0.813523 2.6904 1.01393V10.4342C2.6904 10.6346 2.52849 10.7965 2.32808 10.7965H0.697648C0.49724 10.7965 0.335329 10.6346 0.335329 10.4342V1.01393C0.335329 0.813523 0.49724 0.651611 0.697648 0.651611ZM7.67229 7.17335H9.30272C9.50313 7.17335 9.66504 7.33526 9.66504 7.53567V10.4342C9.66504 10.6346 9.50313 10.7965 9.30272 10.7965H7.67229C7.47188 10.7965 7.30997 10.6346 7.30997 10.4342V7.53567C7.30997 7.33526 7.47188 7.17335 7.67229 7.17335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.2f156510ead3b9d57db850f9762e78f5.svg";
export { ForwardRef as ReactComponent };